import firebase from "firebase";


const firebaseConfig = {
    apiKey: "AIzaSyA8BrNemhlt2HVKP-pkFD7LYO_4fspyZK0",
    authDomain: "project-skripsi-94902.firebaseapp.com",
    projectId: "project-skripsi-94902",
    storageBucket: "project-skripsi-94902.appspot.com",
    messagingSenderId: "850389259628",
    appId: "1:850389259628:web:64421878b53e57c537cf49"
  };
  
  // Initialize Firebase
  
const fire = firebase.initializeApp(firebaseConfig);

export default fire;
